import React from 'react';
import PropTypes from 'prop-types';
import Sortable from 'sortablejs';
import './datatable.css';
class TableBody extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    componentDidMount() {
        if (this.props.onDragDrop) {
            let tableBody = document.getElementById('tbody');
            Sortable.create(tableBody, {
                handle: '.handle',
                chosenClass: 'chosen',
                onEnd: this.props.onDragDrop,
            });
        }
    }

    render() {
        return <tbody id="tbody">{this.props.children}</tbody>;
    }
}
TableBody.propTypes = {
    onDragDrop: PropTypes.func,
    children: PropTypes.any,
};
export default TableBody;
